import { instantToLocalParts, localPartsToInstant } from "./event-time";

export interface NewEventDefaults {
    startsAt: Date;
    eventDuration: number;
}

const leadDays = 7;
const startTime = "10:00";
const durationMinutes = 60;

export const newEventDefaults = (timeZone: string, now: Date): NewEventDefaults => {
    const target = new Date(now.getTime() + leadDays * 24 * 60 * 60 * 1000);
    const parts = instantToLocalParts(target.toISOString(), timeZone);
    return {
        startsAt: localPartsToInstant(parts.date, startTime, timeZone),
        eventDuration: durationMinutes,
    };
};
